import { createAsyncThunk } from '@reduxjs/toolkit'
import toCamel from 'lodash-humps'
import {
  createFetchAsyncThunk,
  csrfToken,
  toSnake,
  throwErrorForErrorResponse,
  errorHandler,
  ErrorPayload
} from '../common'
import { closeModal } from './userSlice'
import type { User, UserState } from './types'

type ThunkConfig = {
  state: { common: { baseUri: string }; user: UserState }
  rejectValue: ErrorPayload
}

type ModifyUserParams = {
  user: Pick<User, 'id' | 'name' | 'email' | 'role'>
} & Record<string, unknown>

export const fetchUsers = createFetchAsyncThunk('user/fetchUsers', 'users')

export const modifyUsers = createAsyncThunk<unknown, Record<string, unknown>, ThunkConfig>(
  'user/modifyUsers',
  async (params, { getState, rejectWithValue, dispatch }) => {
    const { baseUri } = getState().common

    return fetch(`${baseUri}users`, {
      method: 'put',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken()
      },
      body: JSON.stringify(toSnake(params))
    })
      .then(throwErrorForErrorResponse)
      .then(async () => {
        const { currentPage, sort, searchCondition } = getState().user
        dispatch(fetchUsers({ page: currentPage, sort, search: searchCondition }))
        dispatch(closeModal())
        return Promise.resolve({})
      })
      .then(toCamel)
      .catch(errorHandler(rejectWithValue))
      .finally(() => {
        dispatch(closeModal())
      })
  }
)

export const modifyUser = createAsyncThunk<unknown, ModifyUserParams, ThunkConfig>(
  'user/modifyUser',
  async (params, { getState, rejectWithValue, dispatch }) => {
    const { baseUri } = getState().common
    const {
      user: { id }
    } = params

    return fetch(`${baseUri}users/${id}`, {
      method: 'put',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken()
      },
      body: JSON.stringify(toSnake(params))
    })
      .then(throwErrorForErrorResponse)
      .then(async () => {
        const { currentPage, sort, searchCondition } = getState().user
        dispatch(fetchUsers({ page: currentPage, sort, search: searchCondition }))
        dispatch(closeModal())
        return Promise.resolve({})
      })
      .then(toCamel)
      .catch(errorHandler(rejectWithValue))
      .finally(() => {
        dispatch(closeModal())
      })
  }
)
